import { toNum } from "./perfFormat";

// How the basketball performance sections poll a build the server is still
// running (BUILD_SPEC B13: HTTP 202 with { status: "building", retryAfter }
// in seconds): every retryAfter seconds, 4 when the answer gives none, at
// most MAX_POLLS times after the first request; after that the section says
// it is still being prepared. One cadence for the athlete profile
// (useAthletePerformance) and the coach team page (useTeamPerformance).

export const POLL_MS = 4000;
export const MAX_POLLS = 6;
// The pace a retryAfter may set: never faster than a second, never slower
// than 15 seconds (an odd value can neither hammer the server nor stall the
// page).
export const MIN_POLL_MS = 1000;
export const MAX_POLL_MS = 15000;

// The wait before the next poll: the answer's retryAfter (seconds) when it
// is a positive number, kept between MIN_POLL_MS and MAX_POLL_MS; else
// POLL_MS.
export const pollDelay = (retryAfter) => {
  const seconds = toNum(retryAfter);
  if (seconds === null || seconds <= 0) return POLL_MS;
  return Math.max(MIN_POLL_MS, Math.min(seconds * 1000, MAX_POLL_MS));
};
